import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "service/AuthService";

export const signIn = createAsyncThunk("signIn", async (user) => {
  const response = await AuthService.signIn(user);
  return response.data;
});

export const createAccount = createAsyncThunk("createAccount", async (user) => {
  const response = await AuthService.createAccount(user);
  return response.data;
});

export const getUserInfo = createAsyncThunk("getUserInfo", async () => {
  const response = await AuthService.getUserInfo();
  return response.data;
});

export const userSlice = createSlice({
  name: "user",
  initialState: {
    email: "",
    password: "",
    role: "user",
    token: localStorage.getItem("token") || null,
    error: false,
  },
  reducers: {
    resetError: (state) => {
      state.error = false;
    },
    setError: (state) => {
      state.error = true;
    },
    logout: (state) => {
      state.token = null;
      localStorage.removeItem("token");
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signIn.fulfilled, (state, action) => {
      state.email = action.payload.data.email;
      state.token = action.payload.data.access_token;
      state.role = action.payload.data.role;
      localStorage.setItem("token", action.payload.data.access_token);
      state.error = false;
    }),
      builder.addCase(signIn.rejected, (state, action) => {
        state.error = true;
      });
    builder.addCase(getUserInfo.fulfilled, (state, action) => {
      state.role = action.payload.data.role;
      state.error = false;
    }),
      builder.addCase(getUserInfo.rejected, (state, action) => {
        state.error = true;
      });
    builder.addCase(createAccount.fulfilled, (state, action) => {
      state.error = false;
    }),
      builder.addCase(createAccount.rejected, (state, action) => {
        state.error = true;
      });
  },
});

export const { resetError, setError, logout } = userSlice.actions;

export default userSlice.reducer;
